import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  swaggerUrl: string;
  apiUrl: string;
  fileUrl: string;
  serverUrl: string;
  assetsDir: string;
  auth: {
    method: 'jwt';
    skip: boolean;
    redirectPath: string;
  };
  sentryDsl: string;
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'admin',
  appVersion: packageJson.version,
  swaggerUrl: import.meta.env.VITE_SWAGGER_API_URL ?? '',
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  fileUrl: import.meta.env.VITE_STATIC_FILE_URL ?? '',
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  /**
   * Auth
   * @method jwt | amplify | firebase | supabase | auth0
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.monitoring.group.root,
  },
  sentryDsl: import.meta.env.VITE_SENTRY_DSL,
};
